(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollectionListeMapController', CollectionListeMapController);

    CollectionListeMapController.$inject = ['$filter', '$stateParams', '$timeout', 'Agence', 'CollectionListe'];

    function CollectionListeMapController($filter, $stateParams, $timeout, Agence, CollectionListe) {
        var vm = this;

        vm.activePointKey = null;
        vm.areaGeometry = null;
        vm.collectionListe = {};
        vm.filteredRows = [];
        vm.mapPoints = [];
        vm.mapRefreshToken = 0;
        vm.openContractPopup = openContractPopup;
        vm.openPaymentPopup = openPaymentPopup;
        vm.rows = [];
        vm.showContractPopupAction = showContractPopupAction;
        vm.showContracts = true;
        vm.showPaymentPassage = true;
        vm.showPaymentPopupAction = showPaymentPopupAction;
        vm.showPaymentTime = true;
        vm.showPayments = true;
        vm.updateVisibility = updateVisibility;
		vm.mapFitBoundsToken = 0;
		
        if ($stateParams.id) {
            CollectionListe.get({id: $stateParams.id}, function(result) {
                vm.collectionListe = result;
                vm.rows = buildRows(result);
                updateVisibility();
                loadAgencyGeometry(result.agenceId);
            });
        }

        function updateVisibility() {
            vm.activePointKey = null;
            vm.filteredRows = vm.rows.filter(function(row) {
                return (vm.showPayments && row.hasPaymentPoint) || (vm.showContracts && row.hasContractPoint);
            });

            vm.mapPoints = buildVisiblePoints(vm.filteredRows);
            vm.mapRefreshToken += 1;
			vm.mapFitBoundsToken += 1;
        }

        function buildRows(collectionListe) {
            var rows = [];
            var rowIndex = 0;

            angular.forEach(collectionListe.contratCollectionLists || [], function(contratCollectionList) {
                var paymentCoords = buildCoords(contratCollectionList.coordLat, contratCollectionList.coordLon);
                var contractCoords = buildCoords(contratCollectionList.contrat && contratCollectionList.contrat.lat, contratCollectionList.contrat && contratCollectionList.contrat.lon);
                var paymentDate = contratCollectionList.paymentDate;
                var paymentTimestamp = resolveOrderTime(paymentDate, collectionListe.dateFinPeriode);
                var paymentDateLabel = formatDate(paymentDate, collectionListe.dateFinPeriode);
                var contractReference = getContractReference(contratCollectionList);
                var customerName = getCustomerName(contratCollectionList);
                var amountLabel = buildAmountLabel(contratCollectionList);
                var hasRecordedPayment = hasRecordedPaymentValue(contratCollectionList);

                if (!paymentCoords && !contractCoords) {
                    return;
                }

                rows.push({
                    amountLabel: amountLabel,
                    contractGpsLabel: formatCoordinateLabel(contractCoords),
                    contractId: contratCollectionList.contrat ? contratCollectionList.contrat.id : null,
                    contractPoint: contractCoords ? {
                        dateLabel: paymentDateLabel,
                        focusZoom: 17,
                        hasRecordedPayment: hasRecordedPayment,
                        key: 'contract-' + contratCollectionList.id,
                        kind: 'contract',
                        lat: contractCoords.lat,
                        lon: contractCoords.lon,
                        subtitle: customerName,
                        title: contractReference,
                        valueLabel: amountLabel
                    } : null,
                    contractReference: contractReference,
                    customerName: customerName,
                    hasContractPoint: !!contractCoords,
                    hasRecordedPayment: hasRecordedPayment,
                    hasPaymentPoint: !!paymentCoords,
                    id: contratCollectionList.id,
                    paymentDateLabel: paymentDateLabel,
                    paymentGpsLabel: formatCoordinateLabel(paymentCoords, contratCollectionList.coordPrecision),
                    paymentPoint: paymentCoords ? {
                        dateLabel: paymentDateLabel,
                        focusZoom: 17,
                        hasRecordedPayment: hasRecordedPayment,
                        key: 'payment-' + contratCollectionList.id,
                        kind: 'payment',
                        lat: paymentCoords.lat,
                        lon: paymentCoords.lon,
                        orderTime: paymentTimestamp,
                        subtitle: customerName,
                        title: contractReference,
                        valueLabel: amountLabel
                    } : null,
                    paymentTimestamp: paymentTimestamp,
                    rowIndex: rowIndex
                });

                rowIndex += 1;
            });

            rows.sort(function(a, b) {
                return compareOrder(a.paymentTimestamp, b.paymentTimestamp, a.rowIndex, b.rowIndex);
            });

            return rows;
        }

        function buildVisiblePoints(rows) {
            var points = [];
            var paymentSequence = 0;

            angular.forEach(rows || [], function(row) {
                if (vm.showPayments && row.paymentPoint) {
                    paymentSequence += 1;
                    points.push(buildPaymentPoint(row, paymentSequence));
                }

                if (vm.showContracts && row.contractPoint) {
                    points.push(buildContractPoint(row));
                }
            });

            return points;
        }

        function buildPaymentPoint(row, paymentSequence) {
            var point = angular.copy(row.paymentPoint);
            point.sequence = paymentSequence;
            point.markerHtml = buildPaymentMarkerHtml(paymentSequence, row.paymentDateLabel, row.hasRecordedPayment);
            point.iconSize = [68, vm.showPaymentTime ? 54 : 36];
            point.iconAnchor = [18, 18];
            point.popupAnchor = [0, -16];
            return point;
        }

        function buildContractPoint(row) {
            var point = angular.copy(row.contractPoint);
            var backgroundColor = row.hasRecordedPayment ? '#2f855a' : '#c05621';
            point.markerHtml = '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">C</div>';
            point.iconSize = [24, 24];
            point.iconAnchor = [12, 12];
            point.popupAnchor = [0, -12];
            return point;
        }

        function buildPaymentMarkerHtml(paymentSequence, paymentDateLabel, hasRecordedPayment) {
            var badgeLabel = vm.showPaymentPassage ? String(paymentSequence) : '$';
            var backgroundColor = hasRecordedPayment ? '#2f855a' : '#c05621';
            var html = '<div style="display:flex;flex-direction:column;align-items:center;">' +
                '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:18px;' +
                'min-width:30px;height:30px;line-height:26px;text-align:center;font-weight:bold;' +
                'padding:0 6px;box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' +
                escapeHtml(badgeLabel) +
                '</div>';

            if (vm.showPaymentTime && paymentDateLabel) {
                html += '<div style="' +
                    'margin-top:3px;background:rgba(255,255,255,0.92);color:#1a202c;border-radius:10px;' +
                    'padding:2px 6px;font-size:10px;line-height:1.2;white-space:nowrap;' +
                    'box-shadow:0 1px 3px rgba(0,0,0,0.25);">' + escapeHtml(paymentDateLabel) + '</div>';
            }

            html += '</div>';
            return html;
        }

        function openPaymentPopup(row) {
            if (!row || !row.paymentPoint) {
                return;
            }

            focusPoint(row.paymentPoint.key);
        }

        function openContractPopup(row) {
            if (!row || !row.contractPoint) {
                return;
            }

            focusPoint(row.contractPoint.key);
        }

        function focusPoint(pointKey) {
			vm.activePointKey = null;
	
			$timeout(function() {
			    vm.activePointKey = pointKey;
			}, 0);
        }

        function showPaymentPopupAction(row) {
            return vm.showPayments && row && row.hasPaymentPoint;
        }

        function showContractPopupAction(row) {
            return vm.showContracts && row && row.hasContractPoint;
        }

        function loadAgencyGeometry(agenceId) {
            vm.areaGeometry = null;

            if (!agenceId) {
                return;
            }

            Agence.get({id: agenceId}, function(agence) {
                vm.areaGeometry = agence ? agence.geographicCoord : null;
            });
        }

        function resolveOrderTime(paymentDate, fallbackDate) {
            if (paymentDate) {
                return new Date(paymentDate).getTime();
            }
            if (fallbackDate) {
                return new Date(fallbackDate).getTime();
            }
            return 0;
        }

        function formatDate(paymentDate, fallbackDate) {
            if (paymentDate) {
                return $filter('date')(paymentDate, 'shortTime');
            }
            if (fallbackDate) {
                return $filter('date')(fallbackDate, 'mediumDate');
            }
            return '';
        }

        function resolveAmountPaid(contratCollectionList) {
            var amountPaid = contratCollectionList.amountPaid;

            if ((amountPaid === null || amountPaid === undefined || amountPaid === '') && contratCollectionList.lignePaiementService && contratCollectionList.lignePaiementService.length) {
                amountPaid = contratCollectionList.lignePaiementService[0].montantPayeCollecteur;
            }

            return amountPaid;
        }

        function buildAmountLabel(contratCollectionList) {
            var amountPaid = resolveAmountPaid(contratCollectionList);

            if (amountPaid === null || amountPaid === undefined || amountPaid === '') {
                return $filter('translate')('wamasysApp.collectionListe.map.noAmount');
            }

            return $filter('translate')('wamasysApp.collectionListe.map.amount') + ': ' + $filter('number')(amountPaid, 2);
        }

        function hasRecordedPaymentValue(contratCollectionList) {
            var amountPaid = resolveAmountPaid(contratCollectionList);
            var numericAmount;

            if (amountPaid === null || amountPaid === undefined || amountPaid === '') {
                return false;
            }

            numericAmount = parseFloat(String(amountPaid).replace(',', '.'));
            return !isNaN(numericAmount) && numericAmount !== 0;
        }

        function buildCoords(latValue, lonValue) {
            var lat = parseCoordinate(latValue);
            var lon = parseCoordinate(lonValue);

            if (lat === null || lon === null) {
                return null;
            }

            return {
                lat: lat,
                lon: lon
            };
        }

        function formatCoordinateLabel(coords, precision) {
            if (!coords) {
                return '-';
            }

            var label = $filter('number')(coords.lat, 6) + ', ' + $filter('number')(coords.lon, 6);

            if (precision !== null && precision !== undefined && precision !== '') {
                label += ' (' + $filter('number')(precision, 1) + ' m)';
            }

            return label;
        }

        function compareOrder(firstTime, secondTime, firstIndex, secondIndex) {
            if (firstTime !== secondTime) {
                return firstTime - secondTime;
            }

            return firstIndex - secondIndex;
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function getContractReference(contratCollectionList) {
            return contratCollectionList.contrat ? contratCollectionList.contrat.referenceContrat : '';
        }

        function getCustomerName(contratCollectionList) {
            return contratCollectionList.contrat ? contratCollectionList.contrat.nomPersonne : '';
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
    }
})();
